<!-- vlc视频播放器 支持各种视频流,需要依赖于vlc插件-->
<template>
    <div class="player-box" id="streamPlayerId">

        <iframe
                v-if="isOcx"
                style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
                allowtransparency="true"
                src=""
                frameborder="0"
        ></iframe>
        <img class="videoBg"
             :src="require('@/assets/images/video_empty.jpg')"
             alt=""
             v-show="(videoUrl == '' || isLoading || loadFailure || showVlcFlag)">
        <div class="loader" v-show="isLoading">
            <svg
                    version="1.1"
                    class="loader-1"
                    x="0px"
                    y="0px"
                    width="100px"
                    height="100px"
                    viewBox="0 0 50 50"
                    style="enable-background:new 0 0 50 50;"
                    xml:space="preserve"
            >
              <path
                      fill="#000"
                      d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                      transform="rotate(110.097 25 25)">
                <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.6s"
                        repeatCount="indefinite"/>
              </path>
            </svg>
            <div class="load-msg">加载中,请稍后....</div>
        </div>
        <div v-show="!isOcx">
            <div class="tc-player-box" id="videoTcPlayer"></div>
        </div>
        <div v-show="isOcx">
            <object
                    ref="vlcplayerRef"
                    id="vlcplayerRef"
                    v-if="showVlcFlag || loadFailure"
                    classid='clsid:9BE31822-FDAD-461B-AD51-BE1D1C159921'
                    type="application/x-vlc-plugin"
                    :width="width"
                    :height="height">
                <param name="ShowDisplay" value="True" />
                <param name="wmode" value="transparent">
                <param name="AutoPlay" value="true" />
                <param name="branding" value="false" />
                <param name="controls" value="false" />
                <param name="toolbar" value="false" />
            </object>
        </div>

    </div>
</template>
<script>
    import {IEVersion} from '@/utils/index';
    import TcPlayer from "@/plugin/TcPlayer";
    import {ocxVideoPlay} from "@/utils/vlcVideo"

    export default {
        name: 'vlcplayer',
        props: {
            width: {type: String,default: "500"},
            height: {type: String,default: "350"},
            videoUrl:{
                type: String,
                default:''
            },
            limitReloadCount:{
                type: Number,
                default:10,
            },
        },
        watch: {
            videoUrl: {
                handler(newVal, old) {
                    this.reloadUrl(true);
                },
                deep: true,
            },
        },
        data() {
            return {
                player: null,
                refDom: null,
                isOcx:false,
                tcPlayer:null,
                isLoading:false,
                videoBg:require('@/assets/images/video_empty.jpg'),
                showVlcFlag:false,
                loadFailure:false,
                downloadUrl:'http://www.ggniu.cn/download/CaptureInstall.dmg?',
                reloadUrlCount:0,
                checkIframetimer:null,
                lastDecodedFrame:0,
                captureObj:null,
                lastDecodedFrameCount:0,
            }
        },
        created(){

        },
        mounted() {
            this.refDom = document.getElementById("vlcplayerRef");
            this.initVideoPlayer();
            this.InitNiuNiuCut()
         
        },
        methods: {

            InitNiuNiuCut() {
                if(isMacintosh()){
                    this.downloadUrl = 'http://www.ggniu.cn/download/CaptureInstall.dmg?';
                }
                this.captureObj = new NiuniuCaptureObject();
                this.captureObj.NiuniuAuthKey = "niuniu";
                //此处可以设置相关参数
                this.captureObj.TrackColor = rgb2value(255, 0, 0);
                this.captureObj.EditBorderColor = rgb2value(0, 0, 255);

                //设置工具栏的TOOLTIP
                //captureObj.ToolTipText = "tipRectangle|tipCircle|tipArrow|tipBrush|tipGlitter|tipMosaic|tipText|tipUndo|tipSave|tipCancel|tipFinish|Finish";

                //设置控件加载完成以及截图完成的回调函数
                this.captureObj.FinishedCallback = this.OnCaptureFinishedCallback;
                this.captureObj.PluginLoadedCallback = this.PluginLoadedCallback;
                this.captureObj.VersionCallback = this.VersionCallback;

                //初始化控件
                this.captureObj.InitNiuniuCapture();
            },
            downLoadCutPlugin(){

                this.$confirm("当前环境需要先下载插件才能截图", "提示", {
                    confirmButtonText: "下载",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        window.window.open(
                            this.downloadUrl,
                            "_blank"
                        );
                    })
                    .catch(() => {});
            },
            OnCaptureFinishedCallback(type, x, y, width, height, info, content,localpath){
                // type : 1 自定义截图 2 取消截图 3. 截图到本地 4 截图到剪切板
                if(type < 0){
                   alert("安装niu截图控件")
                    this.downLoadCutPlugin()
                    return;
                }

                switch(type)
                {
                    case 1:{
                        var imgFile2 = this.convertBase64UrlToBlob(content);
                        const formData = new FormData();
                        formData.append('file', imgFile2);
                        if(imgFile2){
                            this.$http.post('/bigfileUpload/uploadFile',formData ).then(res => {
                                if(res.data.code == "1"){
                                    var filePath = res.data.data;
                                    this.$emit('cutAndUploadSuccess', filePath);

                                }else{
                                    this.$message({message: "上传失败", type: "error"});
                                }
                            }).catch(e => {

                            })
                        }

                        break;
                    }
                    // case 2:
                    // {
                    //    console.log('您取消了截图');
                    //     break;
                    // }
                    // case 3:
                    // {
                    //     console.log('您保存了截图到本地： x:' + x + ',y:' + y + ',widht:' + width + ',height:' + height);
                    //     UploadCaptureData(content, localpath);
                    //     break;
                    // }
                    // case 4:
                    // {
                    //     if(info =='0')
                    //     {
                    //         console.log('从剪贴板获取到了截图： ' + localpath)
                    //         UploadCaptureData(content, localpath);
                    //     }
                    //     else
                    //     {
                    //         $('#info').html('从剪贴板获取图片失败。');
                    //     }
                    //     break;
                    // }
                }
            },

            //用于返回控件的版本号
             VersionCallback(ver){
                console.log("Version：",ver)
                //captureObj.Version;
                //可以在此根据最新的版本号与控件返回的版本号对比，决定是否要提示升级
            },
            /*
            当控件成功加载后回调的的函数，您可以在此控制相应的UI显示
            */
            PluginLoadedCallback(success){
                if(success){
                    console.log("PluginLoadedSuccess")
                }
            },

            // tcPlayer
            openTcPlayer() {
                var url = this.videoUrl;

                if (this.tcPlayer) {
                    this.tcPlayer.load(url); // 重载url
                } else {
                    this.tcPlayer = TcPlayer({
                        videoId: "videoTcPlayer",
                        height:this.height,
                        width:this.width,
                        controls:"none",
                        url: url,
                        coverpic: this.videoBg,
                        pimg:this.videoBg,
                        listener: (msg) => {
                            const { type, code } = msg;
                            if (type === "error") {
                                this.loadFailure = true;
                                this.$message({message: "视频源错误。", type: "error"});
                            }
                        },
                    });
                }




            },
            pause(){ // 暂停

                if( this.isOcx && this.refDom && this.refDom.playlist && this.refDom.playlist.isPlaying){
                    this.refDom.playlist.stop();
                    this.refDom.playlist.togglePause();
                }else if(this.tcPlayer){
                    this.tcPlayer.pause()
                }

            },
            play(){ //播放

                if(this.isOcx && this.refDom && this.refDom.playlist && !this.refDom.playlist.isPlaying){
                    this.refDom.playlist.play();
                }else if(this.tcPlayer){
                    this.tcPlayer.play()
                }

            },

            reloadUrl(sourceChange){ // 重新加载url

                this.reloadUrlCount++;
                // 重新加载超过10次销毁播放组件不再重新请求
                if(!sourceChange && (this.reloadUrlCount > this.limitReloadCount)){
                    if(this.refDom && this.refDom.playlist && this.refDom.playlist.isPlaying){
                        this.refDom.playlist.stop();
                        // this.refDom.playlist.clear();
                    }
                    this.isLoading = false;
                    return;
                }

                if(sourceChange){
                    this.reloadUrlCount = 0;
                }
               this.initVideoPlayer(sourceChange)

            },

            initVideoPlayer(sourceChange){ // 初始化播放器


                console.log('sourceChange:',this.videoUrl)

                if(this.videoUrl){
                    console.log('this.videoUrl',this.videoUrl)
                    var IEV = IEVersion()
                    this.isOcx = IEV < 11 || (this.videoUrl.indexOf("rtsp:") > -1?true:false);
                    this.showVlcFlag = false;

                    this.$nextTick(()=>{
                        this.isLoading = true;
                        if(this.isOcx){
                            this.ocxVideoPlay()
                        }else{
                            this.openTcPlayer()
                        }
                    })

                }


            },
            ocxVideoPlay() {

                const _this = this;
                this.showVlcFlag = true;
                this.isLoading = false;
                this.$nextTick(()=>{
                    var player = document.getElementById("vlcplayerRef");
                    _this.refDom = player;
                    if(_this.videoUrl){
                        try {

                            ocxVideoPlay({
                                el: 'vlcplayerRef',
                                url: _this.videoUrl,
                                progress: (res) => {
                                    if (res === 100) {
                                        _this.isLoading = false;
                                    }
                                },
                                error: () => {
                                    _this.isLoading = false;
                                    _this.$confirm("当前环境需要先下载插件才能播放", "提示", {
                                        confirmButtonText: "下载",
                                        cancelButtonText: "取消",
                                        type: "warning",
                                    })
                                    .then(() => {
                                        window.window.open(
                                            "http://cjdown.pminfo.cn/pub/vlc-2.2.6-win32.exe",
                                            "_blank"
                                        );
                                    })
                                    .catch(() => {});
                                },
                            });


                        } catch (err) {

                            console.log('error:',err)
                            _this.$confirm("当前环境需要先下载插件才能播放", "提示", {
                                confirmButtonText: "下载",
                                cancelButtonText: "取消",
                                type: "warning",
                            })
                                .then(() => {
                                    window.window.open(
                                        "http://cjdown.pminfo.cn/pub/vlc-2.2.6-win32.exe",
                                        "_blank"
                                    );
                                })
                                .catch(() => {});

                        }

                    }

                })




            },

            //注册事件
            registerVLCEvent(event,handler){
                this.refDom = document.getElementById("vlcplayerRef");
                if(this.refDom.attachEvent){
                    if(this.refDom.attachEvent){
                        this.refDom.attachEvent(event,handler);
                    }else if(this.vlcplayer.addEventListener){
                        this.refDom.addEventListener(event,handler,false);
                    }else{
                        this.refDom["onloadeddata"]=handler;
                    }
                }

            },

           handle_MediaPlayerBuffering (val){
                console.log("缓冲："  + val +  "%");
               this.isLoading = true;
            },

            convertBase64UrlToBlob(urlData){
                var bytes=window.atob(urlData);        //去掉url的头，并转换为byte
                //处理异常,将ascii码小于0的转换为大于0
                var ab = new ArrayBuffer(bytes.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                return new Blob( [ab] , {type : 'image/png'});
            },
            // 视频截图及上传文件服务器
            cutVideoScreen(){

                var posObj = document.getElementById("streamPlayerId").getBoundingClientRect();
                let captureRet = this.captureObj.DoCapture("1.jpg", 0, 1,posObj.left,( posObj.top + 80), posObj.width, posObj.height);
                if(captureRet == 'emCaptureFailed' || captureRet == 'emCaptureUnknown'){
                    this.downLoadCutPlugin();
                }

                return;


            },
        },

        destroyed() {
            clearInterval(this.checkIframetimer)
        },
    }
</script>

<style lang="less" scoped>
    .player-box {
        position: relative;
        width:100%;
        height:100%;
        .tc-player-box{
            width:100%;
            height:100%;
        }
        img.videoBg{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
        .loader {
            width: 140px;
            height: 140px;
            text-align: center;
            position: absolute;
            top: calc(50% - 40px);
            left: calc(50% - 70px);
            padding-top: 15px;
            z-index: 9009;
            border-radius: 5px;


            .loader-1 {
                width: 60px;
                height: 60px;
            }
            svg path,
            svg rect {
                fill: #17a085;
            }
        }
        .load-msg {
            height: 50px;
            line-height: 50px;
            color: #fff;
            font-size: 13px;
            margin-top: 20px;
        }
    }


</style>